import {LOGO_URL} from "../../conf";

const LogoLarge = () => {
    return (
        <div className={'flex flex-row items-center'}>
            <img src={LOGO_URL} className={'rounded-md'}
                 width={50} height={50} alt="Logo"/>
        </div>
    );
}

export default LogoLarge;
